/* Collection page with boost filter javascript - start */

var hide_filter_button = document.querySelector('#hide_filter');
//console.log('hide_filter_button found: ' + hide_filter_button);

if(hide_filter_button){
    hide_filter_button.addEventListener("click", hide_filter_Function);
    hide_filter_button.addEventListener("keydown", function(event) {
        if (event.key === ' ') {
            event.preventDefault();
            hide_filter_Function(event);
        }
    });
    function hide_filter_Function(event) {
        if (event) event.preventDefault();
        var ProductGridContainer = document.querySelector('#ProductGridContainer');
        ProductGridContainer.classList.toggle('hide_filter_active');
        hide_filter_button.classList.toggle('active');

        if(hide_filter_button.classList.contains('active')){
            hide_filter_button.innerText = 'Show Filter';
            hide_filter_button.setAttribute('aria-expanded', 'false');
            //console.log('Show');
        }
        else{
            hide_filter_button.innerText = 'Hide Filter';
            hide_filter_button.setAttribute('aria-expanded', 'true');
            //console.log('Hide');
        }
        //console.log('hide_filter_button clicked');
    }
}


/* Collection page with boost filter javascript - end */

/* Collection page tabs javascript - start */







filtertabs = document.querySelectorAll('.filter-container a');

if(filtertabs){
    current_url = window.location.href;
    //console.log(window);
    //console.log('current_url: ' + current_url);
    let result = current_url.includes("Aactivity_tag");
    //console.log('result: ' + result);
    filtertabs.forEach(function (item, index){
        //.getAttribute('href')
        if(item == current_url){
            //console.log(' The index is ' + index +' The item is: ' + item);
            const datacol = String(item).split('Aactivity_tag=').slice(1).join("Aactivity_tag=") ; // prints: 20202-03
            var datacolfilter = datacol.replace(/<a.*>.*?<\/a>/ig,'').replace('%20','');
            //console.log('datacolfilter: ' + datacolfilter);

            filtertabsactive = document.querySelector('.filter-container a[data-collection="'+datacolfilter+'"]');
            filtertabsfirst = document.querySelector('.filter-container a');

            if(filtertabsactive != null){
                filtertabsfirst.classList.remove('active');
                filtertabsactive.classList.add('active');
            }
            else{
                filtertabsfirst.classList.add('active');
            }
        }
    });
}
/* Collection page tabs javascript - end */


/* Boost PFS accessibility fixes - start */
(function () {
    // Boost only sets aria-checked="true" when an option is selected; unselected ones need an explicit "false"
    function syncFilterCheckboxes() {
        document.querySelectorAll('.boost-pfs-filter-option-item [role="checkbox"]').forEach(function (checkbox) {
            var selected = checkbox.parentElement.classList.contains('selected');
            checkbox.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
    }

    // Zero-height placeholder injected by Boost: not a real control, so it can't carry aria-label
    function hideScrollToTopPlaceholder() {
        var placeholder = document.querySelector('.boost-pfs-filter-scroll-to-top');
        if (!placeholder || placeholder.getAttribute('aria-hidden') === 'true') return;
        placeholder.removeAttribute('aria-label');
        placeholder.setAttribute('aria-hidden', 'true');
    }

    var scheduled = false;
    function run() {
        scheduled = false;
        syncFilterCheckboxes();
        hideScrollToTopPlaceholder();
    }

    new MutationObserver(function () {
        if (!scheduled) {
            scheduled = true;
            setTimeout(run, 50);
        }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    run();
})();
/* Boost PFS accessibility fixes - end */
